import { AttributesMixin, define, Model, type } from "@type-r/models";
import { RemittanceAdvice } from "./remittanceAdvice";

export interface RemittanceAdviceVaultCard extends AttributesMixin<typeof RemittanceAdviceVaultCard> { }
@define
export class RemittanceAdviceVaultCard extends Model {

    static idAttribute = "id";

    static attributes = {
        stateId: Number,
        createdOn: type(Date),
        uid: String,
        dataset: type(RemittanceAdvice).dontSave,
        hashKey: String,
        updatedOn: type(Date),
        eTag: String,
        assetTypeId: Number,
        dataSourceId: Number,
        platformCode: String,
        createdBy: String
    };
}